import { UserInfo } from '../models/user';
import { SubscriptionStatus } from '../models/organization';

const chargebeeCheckoutHandler = (profile: UserInfo, successCallback, closeCallback) => {
  const cbInstance = window.Chargebee.getInstance();

  const cart = cbInstance.getCart();

  // TODO: add correct quantity
  const product = cbInstance.initializeProduct(process.env.CHARGEBEE_PRODUCT_MONTHLY, 1);
  cart.setCustomer({
    email: encodeURIComponent(profile.email),
    cf_org_id: profile.orgId,
  });
  cart.replaceProduct(product);
  cbInstance.setCheckoutCallbacks(() => ({
    success: successCallback,
    close: closeCallback
  }));
  cart.proceedToCheckout();
};

export const isInactiveSubscription = (org) => {
  return ([SubscriptionStatus.NonRenewing, SubscriptionStatus.Paused, SubscriptionStatus.Cancelled].indexOf(org?.billing_subscription?.current_plans?.status) > -1
    && org?.billing_subscription?.expiration <= Date.now()/1000);
};

export default chargebeeCheckoutHandler;
